import Joi from '@hapi/joi';

export const equipmentTypeSchema = Joi.object().keys({
    name: Joi.string().required(),
    isPayload: Joi.boolean().allow(null, ''),
    hasLog: Joi.boolean().allow(null, ''),
});

export const equipmentSchema = Joi.object().keys({
    partOfEquipmentId: Joi.string().allow(null, ''),
    equipmentTypeId: Joi.string().required(),
    clientCompanyId: Joi.string().allow(null, ''),
    name: Joi.string().required(),
    description: Joi.string().allow(null, ''),
    manufacturer: Joi.string().allow(null, ''),
    typeIndication: Joi.string().allow(null, ''),
    version: Joi.string().allow(null, ''),
    softwareVersion: Joi.string().allow(null, ''),
    serialNumber: Joi.string().allow(null, ''),
    status: Joi.string().required(),
    dateInUse: Joi.date().allow(null, ''),
    dateOutOfUse: Joi.date().allow(null, ''),
    dateStartCertificateValidity: Joi.date().allow(null, ''),
    dateEndCertificateValidity: Joi.date().allow(null, ''),
    dateReminderRecertification: Joi.date().allow(null, ''),
    remarks: Joi.string().allow(null, ''),
});
